// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PropertyValue-base__pksa4{display:flex;flex-grow:1;align-items:stretch;justify-content:stretch}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "PropertyValue-base__pksa4"
};
export default ___CSS_LOADER_EXPORT___;
